import { AFFECTS } from "../constants/pricingConstants"

/**
 * Price adjustments set to selected ticket types, for warning before one of those ticket types is
 * deleted. Deleting it takes it out of each adjustment on the server, and one left with none is
 * deleted there too.
 *
 * The wizard holds adjustments in form fields once the Pricing step has been opened; before that, the
 * saved listing's are used.
 */
const ADJUSTMENT_KINDS = [
  { formField: "dayAdjustments", savedField: "day_adjustments" },
  { formField: "seasonalAdjustments", savedField: "seasonal_adjustments" }
]

/**
 * After the Ticket Type step saves: when it deleted a ticket type, the server has changed the
 * adjustments (and saved them afresh, with new ids), so the wizard's copies are emptied and the
 * Pricing step reloads them, rather than later saving stale ones.
 */
export const clearAdjustmentsAfterTicketTypeDeletion = (form) => {
  if (!(form.getFieldValue("ticket_types") || []).some((ticketType) => ticketType._destroy)) return
  ADJUSTMENT_KINDS.forEach(({ formField }) => form.setFieldValue(formField, []))
}

const adjustmentsOfKind = (form, trip, { formField, savedField }) => {
  const inWizard = form.getFieldValue(formField)
  if (inWizard?.length) return inWizard
  return (trip?.[savedField] || []).map((saved) => ({ id: saved.id, name: saved.name, affects: saved.affects, selectedTickets: saved.selected_ticket_ids || [] }))
}

/** The names of the adjustments a ticket type is selected in. */
export const getAdjustmentsUsingTicketType = (ticketTypeId, { form, trip }) =>
  ADJUSTMENT_KINDS.flatMap((kind) =>
    adjustmentsOfKind(form, trip, kind)
      .filter((adjustment) => !adjustment._destroy && adjustment.affects === AFFECTS.SELECTED && (adjustment.selectedTickets || []).includes(ticketTypeId))
      .map((adjustment) => adjustment.name)
  )
